import { Card, VStack } from "@gluestack-ui/themed";
import { Icon } from "@repo/core/components/core/Icon";
import { Text } from "@repo/core/components/core/Text";
import { CardStatusProps } from "@repo/core/screens/Proposals/screens/ProposalsViewInfo/components/CardStatus/types";

export const CardStatus = ({
  title,
  titleColor = "$textLight900",
  children
}: CardStatusProps) => {
  return (
    <Card
      bgColor="$backgroundLight50"
      p="$4"
      borderRadius="$2xl"
      alignItems="center"
      justifyContent="center"
    >
      <VStack gap="$2" maxWidth="$102" alignContent="center">
        <VStack gap="$1" alignItems="center" justifyContent="center">
          <Icon
            name="circle-xmark"
            variant="solid"
            color="$error400"
            size="24"
          />
          <Text mt="$1" fontSize="$md" color={titleColor} fontWeight={600}>
            {title}
          </Text>
        </VStack>
        <VStack alignItems="center" justifyContent="center">
          {children}
        </VStack>
      </VStack>
    </Card>
  );
};
